import { FC } from 'react';
import { IProof } from 'src/ts/interfaces';
import { FormValues, getEffectiveProofResult, getRulingIcon } from '../helpers/proofHelpers';
import {
  DocumentId,
  NoThumbnailMessage,
  PreviewContainer,
  PreviewFooter,
  PreviewHeader,
  PreviewImage,
  ProofPreviewContainer,
  RulingIcon,
  RulingText
} from '../styles';

interface ProofPreviewProps {
  proof: IProof;
  applicantName?: string;
  isVisible: boolean;
  position: { x: number; y: number };
  localFormData: Record<string, FormValues>;
}

const ProofPreview: FC<ProofPreviewProps> = ({
  proof,
  applicantName = 'Unknown',
  isVisible,
  position,
  localFormData
}) => {
  const getDocumentRulingText = (proof: IProof) => {
    const result = getEffectiveProofResult(proof, localFormData[proof.id]);

    if (!result || result === 'PENDING') return 'PENDING';

    switch (result) {
      case 'CLEAN':
        return 'CLEAN';
      case 'EDITED':
        return 'EDITED';
      case 'UNDETERMINED':
        return 'INSUFFICIENT';
      default:
        return 'PENDING';
    }
  };

  const rulingStatus = getDocumentRulingText(proof);

  return (
    <PreviewContainer isVisible={isVisible} x={0} y={0}>
      <PreviewHeader>
        <DocumentId>{proof.short_id || proof.id}</DocumentId>
      </PreviewHeader>

      <ProofPreviewContainer>
        {proof.thumb ? (
          <PreviewImage src={proof.thumb} alt={`Preview of ${proof.short_id || proof.id}`} />
        ) : (
          <NoThumbnailMessage>No thumbnail available</NoThumbnailMessage>
        )}
      </ProofPreviewContainer>

      <PreviewFooter>
        <RulingIcon src={getRulingIcon(proof, localFormData)} alt="Ruling status" />
        <RulingText status={rulingStatus}>{rulingStatus}</RulingText>
      </PreviewFooter>
    </PreviewContainer>
  );
};

export default ProofPreview;
